module.exports = __webpack_public_path__ + "media/icons/tapicerka-materialowa-active-7bc70edd.png";